const totle = 64;
export const getToleRoles = () => {
  let roles = []
  for (let i = 1; i <= totle; i++) {
    roles.push(i)
  }
  return roles
}
const reduceRoleIds = (role, map) => {
  role.forEach(v => {
    map[v.id] = v
    if (v.children) {
      reduceRoleIds(v.children, map)
    }
  })
}
export const getRolesMap = () => {
  let _map = {}
  reduceRoleIds(rolesList, _map)
  return _map
}

const reduceParentId = (rolesMap, role, list) => {
  if (role !== -1 && rolesMap[role] && rolesMap[role].hasOwnProperty('parentId')) {
    list.push(rolesMap[role].parentId)
    reduceParentId(rolesMap, rolesMap[role].parentId, list)
  }
}
export const getFullRolesId = (roleIds) => {
  const rolesMap = getRolesMap()
  let fullRoles = [...roleIds]
  roleIds.forEach(v => {
    reduceParentId(rolesMap, v, fullRoles)
  })
  return Array.from(new Set(fullRoles))
}

const rolesList = [
  {
    id: 1,
    label: "分类管理",
    children: [
      {
        id: 2,
        label: "添加分类",
        parentId: 1
      },
      {
        id: 3,
        label: "修改分类",
        parentId: 1
      },
      {
        id: 4,
        label: "删除分类",
        parentId: 1
      },
    ],
  },
  {
    id: 45,
    label: "履约类型",
    children: [
      {
        id: 46,
        label: "添加类型",
        parentId: 45
      },
      {
        id: 47,
        label: "修改类型",
        parentId: 45
      },
      {
        id: 48,
        label: "删除类型",
        parentId: 45
      },
      // {
      //   id: 49,
      //   label: "查看类型",
      //   parentId: 1
      // },
    ],
  },
  {
    id: 5,
    label: "渠道管理",
    children: [
      {
        id: 6,
        label: "添加渠道",
        parentId: 5
      },
      {
        id: 7,
        label: "修改渠道",
        parentId: 5
      },
      {
        id: 8,
        label: "删除渠道",
        parentId: 5
      },
    ],
  },
  {
    id: 9,
    label: "商品管理",
    children: [
      {
        id: 10,
        label: "添加商品",
        parentId: 9
      },
      {
        id: 11,
        label: "修改商品",
        parentId: 9
      },
    ],
  },
  {
    id: 33,
    label: "故障管理",
    children: [
      {
        id: 34,
        label: "添加故障",
        parentId: 33
      },
      {
        id: 35,
        label: "修改故障",
        parentId: 33
      },
      {
        id: 36,
        label: "删除故障",
        parentId: 33
      },
    ],
  },
  {
    id: 37,
    label: "机型管理",
    children: [
      {
        id: 38,
        label: "添加机型",
        parentId: 37
      },
      {
      id: 39,
        label: "修改机型",
        parentId: 37
      },
      {
        id: 40,
        label: "删除机型",
        parentId: 37
      },
    ],
  },
  {
    id: 12,
    label: "品牌管理",
    children: [
      {
        id: 13,
        label: "添加品牌",
        parentId: 12
      },
      {
        id: 14,
        label: "修改品牌",
        parentId: 12
      },
      {
        id: 15,
        label: "删除品牌",
        parentId: 12
      },
    ],
  },
  {
    id: 41,
    label: "机型管理",
    children: [
      {
        id: 42,
        label: "添加机型",
        parentId: 41
      },
      {
        id: 43,
        label: "修改机型",
        parentId: 41
      },
      {
        id: 44,
        label: "删除机型",
        parentId: 41
      },
    ],
  },
  // {
  //   id: 16,
  //   label: "激活码管理",
  //   children: [
  //     {
  //       id: 17,
  //       label: "添加激活码",
  //       parentId: 16
  //     },
  //     {
  //       id: 18,
  //       label: "审核激活码",
  //       parentId: 16
  //     },
  //     {
  //       id: 19,
  //       label: "修改激活码",
  //       parentId: 16
  //     },
  //     {
  //       id: 20,
  //       label: "重置激活码",
  //       parentId: 16
  //     },
  //     {
  //       id: 21,
  //       label: "删除激活码",
  //       parentId: 16
  //     },
  //     {
  //       id: 22,
  //       label: "查看激活码",
  //       parentId: 16
  //     },
  //     {
  //       id: 23,
  //       label: "导入激活码",
  //       parentId: 16
  //     },
  //     {
  //       id: 29,
  //       label: "导出激活码",
  //       parentId: 16
  //     },
  //     {
  //       id: 24,
  //       label: "批量删除",
  //       parentId: 16
  //     },
  //   ],
  // },

  {
    id: 16,
    label: "激活码管理",
    children: [
      {
        id: 50,
        label: "激活码管理",
        parentId: 16,
        children: [
         {//50
          id: 51,
          label: "添加激活码",
          parentId: 50
        },
        {
          id: 52,
          label: "查看激活码",
          parentId: 16
        },
        {
          id: 59,
          label: "修改激活码",
          parentId: 50
        },
        {
          id: 53,
          label: "重置激活码",
          parentId: 50
        },
        {//50
          id: 54,
          label: "删除激活码",
          parentId: 50
        },
        {
          id: 56,
          label: "导入激活码",
          parentId: 50
        },
        {//50
          id: 57,
          label: "导出激活码",
          parentId: 50
        },
        {
          id: 58,
          label: "批量删除",
          parentId: 50
        },
        ],
      },
      {
        id: 60,
        label: "激活码审核",
        parentId: 16,
        children: [
        {
          id: 61,
          label: "审核激活码",
          parentId: 60
        },
        {
          id: 62,
          label: "重置激活码",
          parentId: 60
        },
        ],
      },
    ],
  },
  {
    id: 25,
    label: "订单管理",
    children: [
      {
        id: 26,
        label: "查看激活码",
        parentId: 25
      },
      {
        id: 27,
        label: "修改备注",
        parentId: 25
      },
      {
        id: 28,
        label: "修改状态",
        parentId: 25
      },
      {
        id: 29,
        label: "导出",
        parentId: 25
      },
    ],
  },
  {
    id: 31,
    label: "系统管理",
    children: [
      {
        id: 32,
        label: "系统日志",
        parentId: 31
      },
    ],
  },
  {
    id: 30,
    label: "Dashbord",
  }
];

export default rolesList